<script>
    import HamburgerOptionsMixin from "../../../author/pagesbuilder/mixins/HamburgerOptionsMixin";

    export default {
        name: "TextElement",
        mixins: [HamburgerOptionsMixin],
        data () {
            return {
                elementType: 'text'
            }
        }
    }
</script>
